import { Tabs } from "@shared/ui/tabs";
import { useJobCardDetail, useJobCardSignatureReport } from "../../hooks";
import { InfoCard } from "./InfoCard";
import { QuickActions } from "./QuickActions";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button } from "@shared/ui/button";
import { ArrowLeft } from "lucide-react";
import { TasksTab } from "./tabs/Task";
import { MaterialsTab } from "./tabs/Materials";
import { ReadingsTab } from "./tabs/Readings";
import { HelpResourcesTab } from "./tabs/HelpResources";
import { Overview } from "./tabs/Overview";
import { SafetyTab } from "./tabs/Safety";

export const DetailLanding = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, serviceType } = useParams<{ id: string; serviceType: string }>();

  const handleBack = () => {
    const path = location.pathname.toLowerCase();
    let tab = "pending";
    if (path.includes("assigned-")) tab = "assigned";
    else if (path.includes("completed-")) tab = "completed";
    else if (path.includes("rejected-")) tab = "rejected";
    else if (path.includes("history-")) tab = "history";

    navigate(`/service-orders/dispatcher?page=1&tab=${tab}`);
  };

  const path = location.pathname.toLowerCase();
  const isReportMode = path.includes("completed-") || path.includes("history-");
  const isHistoryMode = path.includes("history-");
  const isCompletedMode = path.includes("completed-");

  const { data: jobCardResponse } = useJobCardDetail({
    id: id,
  });

  const { data: signatureReportData } = useJobCardSignatureReport(id, {
    enabled: !!id,
  });

  const tabComponents: any = {
    Overview: {
      label: "Overview",
      component: (
        <Overview
          jobCard={jobCardResponse}
          signatureReportData={signatureReportData}
        />
      ),
    },
    Safety: {
      label: "Safety",
      component: <SafetyTab jobCard={jobCardResponse} />,
    },
    Tasks: {
      label: "Tasks",
      component: (
        <TasksTab
          jobCard={jobCardResponse}
          isReport={isReportMode}
          id={id}
          isHistory={isHistoryMode}
          isCompleted={isCompletedMode}
        />
      ),
    },
    Materials: {
      label: "Materials",
      component: (
        <MaterialsTab
          jobCard={jobCardResponse}
          isReport={isReportMode}
          id={id}
          isHistory={isHistoryMode}
          isCompleted={isCompletedMode}
        />
      ),
    },
    Readings: {
      label: "Readings",
      component: (
        <ReadingsTab
          jobCard={jobCardResponse}
          isReport={isReportMode}
          id={id}
          isHistory={isHistoryMode}
          isCompleted={isCompletedMode}
        />
      ),
    },
    ...(!isHistoryMode
      ? {
          Help: {
            label: "Help",
            component: <HelpResourcesTab jobCard={jobCardResponse} />,
          },
        }
      : {}),
  };

  return (
    <>
      <div className="flex items-center gap-4 mb-2">
        <Button
          variant="ghost"
          size="icon"
          onClick={handleBack}
          className="h-8 w-8 rounded-full hover:bg-gray-100"
        >
          <ArrowLeft className="h-5 w-5 text-gray-700" />
        </Button>
        <div>
          <h1 className="text-xl font-semibold text-gray-900">
            Back to Service Order List
          </h1>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 lg:col-span-9">
          <InfoCard jobCard={jobCardResponse} />
        </div>
        <div className="col-span-12 lg:col-span-3">
          <QuickActions jobCard={jobCardResponse} />
        </div>
      </div>

      <Tabs
        className="mt-4"
        defaultValue="Overview"
        tabComponents={tabComponents}
        tabsListClassName={`grid ${isHistoryMode ? "grid-cols-5" : "grid-cols-6"}`}
      />
    </>
  );
};
